import {z} from '@hono/zod-openapi';

import {ISSUE_REPORT_DIAGNOSTICS_LIMITS as LIMITS} from './ISSUE_REPORT_DIAGNOSTICS_LIMITS';

export const issueReportAffectedRecordSchema = z
  .object({
    // Keep in sync with ASSISTANT_CONTEXT_ENTITY_KINDS in ai-assistant-core; validations must remain a dependency-free workspace leaf.
    kind: z.enum(['businessCase', 'customer', 'interest', 'rentalOrder', 'vehicle']),
    id: z.string().min(1).max(64),
    label: z.string().min(1).max(LIMITS.affectedRecordLabel).optional(),
    url: z.string().max(LIMITS.url).optional(),
  })
  .openapi('IssueReportAffectedRecord');

export type IssueReportAffectedRecord = z.infer<typeof issueReportAffectedRecordSchema>;
